<template>
  <div>
    <table class="table table-striped table-responsive">
      <thead>
        <tr>
          <th scope="col">
            Position
            <span v-tooltip="'The ranking for a keyword when searched for in Google.'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
          <th scope="col">
            Domain
            <span v-tooltip="'The name seen in the URL bar'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
          <th scope="col">
            Content
            <span v-tooltip="'Determines the total number of words found on the website'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
          <th scope="col">
            Backlinks
            <span v-tooltip="'The amount of incoming hyperlinks from one web page to your website'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
          <th scope="col">
            Domain Age
            <span v-tooltip="'How old the domain is'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
          <!-- <th scope="col">
            Page Count
            <span v-tooltip="'Tooltip with description goes here...'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th> -->
          <th scope="col">
            Load Time
            <span v-tooltip="'How long it takes the site to load'">
              <i
                class="text-primary fa fa-info-circle"
              />
            </span>
          </th>
        </tr>
      </thead>
      <tbody
        is="transition-group"
        name="list"
      >
        <table-row
          v-for="(result, index) in results"
          :key="index"
          :item="result"
          :active="formatUrl(result.url) === url"
          :is-busy="isBusy(result.uuid)"
          :has-error="hasError(result.uuid)"
          @on-refetch="onRefetch"
        />
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import TableRow from './Row';

export default {
  components: {
    TableRow
  },

  props: {
    results: {
      type: Array,
      required: true
    },
    selectedKeyword: {
      type: String
    },
    url: {
      type: String
    },
  },

  computed: mapState('keyword', ['fetchingAdditionalResults','additionalResultErrors']),


  methods:{

    ...mapActions('app', ['updateCompetitorByDomain', 'appendCompetitorError']),

    onRefetch({ data }) {
      console.log(data);
      this.$emit('on-refetch', data)
    },

    isBusy(uuid) {
      return this.fetchingAdditionalResults.includes(uuid)
    },

    hasError(uuid) {
      return this.additionalResultErrors.includes(uuid)
    },

  },


}
</script>
<style lang="scss" scoped>
  .table thead th {
    border: none;
  }
  .table-responsive {
    display: inline-table;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
</style>
